module.exports = __webpack_public_path__ + "img/artillery-range.1d3a5e0f.png";